export const ROUTE_HOME = '/'
export const ROUTE_LIVING_ENVIRONMENT = '/hyvan-elaman-asuinymparisto'
export const ROUTE_ROUTINES = '/hyvan-arjen-rutiinit'
export const ROUTE_FELLOW_TRAVELERS = '/hyvan-elaman-kanssakulkijat'
export const ROUTE_INSPIRERS = '/hyvan-elaman-innostajat'
export const ROUTE_INCOME = '/hyvan-elaman-toimeentulo'
